
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
        <div class="container"  >
            <div class="row">

                <div class="col-sm-12 text-center"  style="color:#000;font-size:30px;font-family: open-sans">
                        Login As a Service Provider
                </div>

            </div>
                <div  >

                    </div>
                    <div class="form-group" *ngIf='userStatus === 0; else AlreadyLoggedIn'  >
                            <form class="form-horizontal"  [formGroup]="loginform"  >

                                    <div class="form-group">
                                            <label for="email" >Email</label>
                                        <input type="text" name="email" id="email" placeholder=" Type email Id here" [(ngModel)]="loginform.email" class="form-control" formControlName="email" required>
                                        </div>
                                        <div *ngIf="( loginform.get('email').hasError('required') || loginform.get('email').hasError('pattern') ) && loginform.get('email').touched">

                                        <div class="error" style="color:red;font-size:10px" *ngIf="loginform.get('email').hasError('required') && loginform.get('email').touched">
                                            Email is required
                                        </div>
                                        <div class="error" style="color:red;font-size:10px" *ngIf="loginform.get('email').hasError('pattern') && loginform.get('email').touched">
                                              Enter Correct Email Id
                                        </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="password">Password</label>
                                        <input type="password" name="password" id="password" [(ngModel)]="loginform.password" class="form-control" formControlName="password" required>
                                        </div>

                                        <div *ngIf="( loginform.get('password').hasError('required')) && loginform.get('password').touched">

                                            <div class="error" style="color:red;font-size:10px" *ngIf="loginform.get('password').hasError('required') && loginform.get('password').touched">
                                            Password is required
                                            </div>

                                          </div>

                                    <div class="row">
                                            <div class="col-sm-6">
                                                    <button  class="btn btn-success2 btn-block"  (click)="onSubmit()" [disabled]="!loginform.valid" >Sign In</button>
                                            </div>
                                            <div class="col-sm-6">
                                                    <button class="btn btn-secondary btn-block" >Request To Join With us</button>
                                                </div>

                                    </div>

                                  <div class=row>
                                      <div class="col-sm-12 text-center" >
                                           <u><a style="cursor: pointer; font-size:20px; color:#9b7544;" routerLink="/forgotpassword">Forgot Password ??</a></u>
                                      </div>
                                  </div>


                                    </form>
                    </div>
        
           </div>

                <div class="blockquote-footer text-center"  style="background-color: #cb983f;margin-top: 5%; " >
                            <div class="footer-copyright">
                                    <div class="container-fluid" style="font-family: open-sans; font-size:25px; color: #fff">
                                     © 2017 Copyright:   Blends pet Solution

                                    </div>
                                </div>

                    </div>

                    <ng-template #AlreadyLoggedIn>
                            <div  *ngIf='userStatus === 1' style="color:#cb983f;font-size:15px">
                                    Service Provider is Already Logged In...
                                    <p>Automatically redirect to Dashboard after {{ctimer}} seconds</p>
                                   <a routerLink="/doctor"> <p> click here to redirect to Homepage</p></a>
                                </div>

                    </ng-template>
